import { jsxs as d, jsx as l } from "react/jsx-runtime";
import { getMainIconProps as o } from "./index.es2361.js";
function h(t) {
  const { outline: e, fill: n, size: i } = o(t);
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: i,
      height: i,
      viewBox: "0 0 16 17",
      fill: "none",
      children: [
        /* @__PURE__ */ d("g", { clipPath: "url(#clip0_11773_150496)", children: [
          /* @__PURE__ */ l(
            "path",
            {
              d: "M8.48369 6.86235L6.6875 0.125H0.5C0.223858 0.125 0 0.348858 0 0.625V9.73611L8.13459 7.47286C8.3986 7.3994 8.55429 7.12714 8.48369 6.86235Z",
              fill: n
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M8.48369 6.86235C8.55429 7.12714 8.3986 7.3994 8.13459 7.47286L0 9.73611V0.625C0 0.348858 0.223858 0.125 0.5 0.125H6.6875L8.48369 6.86235ZM0.75 0.875H6.11126L7.6953 6.81659L0.75 8.74895V0.875Z",
              fill: e
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M10.4627 6.93255C10.1958 7.00429 9.92126 6.84583 9.84989 6.57879L8.125 0.125H15.5C15.7761 0.125 16 0.348858 16 0.625V5.44444L10.4627 6.93255ZM15.25 4.86939L10.5098 6.14328L9.10178 0.875H15.25V4.86939Z",
              fill: e
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.15581 9.82166C4.88942 9.89337 4.73143 10.1673 4.80278 10.4338L6.32642 16.1251H15.5C15.7762 16.1251 16 15.9012 16 15.6251V6.90283L5.15581 9.82166ZM5.59183 10.481L6.90205 15.3751H15.25V7.88139L5.59183 10.481Z",
              fill: e
            }
          ),
          /* @__PURE__ */ l(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M2.85188 10.432C3.11813 10.3621 3.39079 10.5206 3.46187 10.7865L4.88889 16.1251H0.5C0.223858 16.1251 0 15.9012 0 15.6251V11.1807L2.85188 10.432ZM0.75 15.3751V11.7592L2.80158 11.2206L3.91208 15.3751H0.75Z",
              fill: e
            }
          )
        ] }),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "clip0_11773_150496", children: /* @__PURE__ */ l("rect", { width: "16", height: "16", fill: "white", transform: "translate(0 0.125)" }) }) })
      ]
    }
  );
}
h.__tags = [];
export {
  h as ZipCodeIcon
};
//# sourceMappingURL=index.es371.js.map
